import styled from "styled-components";

export const RowDiv = styled("div")<{
    colGap: number;
    hasOverflow?: boolean;
}>`
    margin: ${(props) => -1 * (props.colGap || 0)}px 0;
    overflow: ${(props) => (props.hasOverflow ? "auto" : "initial")};
`;
